import { WebApiService } from '../../../plugins/webApiService'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import GetByIdRequest from '../../../users/base/i-service/models/requests/GetByIdRequest';
import OwnedUsersRequest from '../../../projects/performers/i-service/model/request/OwnedUsersRequest';
import GetOwnedUsersWithAccessRequest from '../../../projects/performers/i-service/model/request/GetOwnedUsersWithAccessRequest';
import GetUserRoleByTaskIdsRequset from '../../../projects/performers/i-service/model/request/GetUserRoleByTaskIdsRequset';
import GetOwnedDetailUsersRequest from '../../../projects/performers/i-service/model/request/GetOwnedDetailUsersRequest';
import AdminsListForProjectRequest from '../../../projects/performers/i-service/model/request/AdminsListForProjectRequest';
import GetAdminsListForProjectDetailRequest from '../../../projects/performers/i-service/model/request/GetAdminsListForProjectDetailRequest';
import GetEmployeesWithAccessToProjectRequest from '../../../projects/performers/i-service/model/request/GetEmployeesWithAccessToProjectRequest';
import GetUserListAccessQueueTaskRequest from '../../../projects/performers/i-service/model/request/GetUserListAccessQueueTaskRequest';
import WsResponseModelT from '../../../schema-builder/server/models/WsResponseModelT';
import GetByIdResponse from '../../../users/base/i-service/models/responses/GetByIdResponse';
import OwnedUsersResponse from '../../../projects/performers/i-service/model/response/OwnedUsersResponse';
import GetOwnedUsersWithAccessResponse from '../../../projects/performers/i-service/model/response/GetOwnedUsersWithAccessResponse';
import GetUserRoleByTaskIdsResponse from '../../../projects/performers/i-service/model/response/GetUserRoleByTaskIdsResponse';
import GetOwnedDetailUsersResponse from '../../../projects/performers/i-service/model/response/GetOwnedDetailUsersResponse';
import ShortProfile from '../../../users/profile/i-service/models/ShortProfile';
import GetAdminsListForProjectDetailResponse from '../../../projects/performers/i-service/model/response/GetAdminsListForProjectDetailResponse';
import GetEmployeesWithAccessToProjectResponse from '../../../projects/performers/i-service/model/response/GetEmployeesWithAccessToProjectResponse';
import GetUserListAccessQueueTaskResponse from '../../../projects/performers/i-service/model/response/GetUserListAccessQueueTaskResponse';

/**
 * * Сервис для получения списков сотрудников
 */
export default class PerformersListService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	
	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
	}

	/**
	 * * Получение информации о пользователе по Id
	 */
	async GetById(request: GetByIdRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersListService',
			Method: 'GetById',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить список пользователей и краткую информацыю о них
	 */
	async GetOwnedUsers(request: OwnedUsersRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersListService',
			Method: 'GetOwnedUsers',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка пользователей с краткой информацией и доступами по проекту/рабочей области
	 */
	async GetOwnedUsersWithAccess(request: GetOwnedUsersWithAccessRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersListService',
			Method: 'GetOwnedUsersWithAccess',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение доступа по номеру задачи
	 */
	async GetUserRoleByTaskIds(request: GetUserRoleByTaskIdsRequset) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersListService',
			Method: 'GetUserRoleByTaskIds',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить список пользователей и краткую информацыю о них с проектами
	 */
	async GetOwnedDetailUsers(request: GetOwnedDetailUsersRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersListService',
			Method: 'GetOwnedDetailUsers',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить список админов проекта
	 */
	async GetAdminsListForProject(request: AdminsListForProjectRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersListService',
			Method: 'GetAdminsListForProject',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение детального списка админов проекта
	 */
	async GetAdminsListForProjectDetail(request: GetAdminsListForProjectDetailRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersListService',
			Method: 'GetAdminsListForProjectDetail',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка сотрудников с доступом к проекту
	 */
	async GetEmployeesWithAccessToProject(request: GetEmployeesWithAccessToProjectRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersListService',
			Method: 'GetEmployeesWithAccessToProject',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка пользователей которым доступна очередь задач
	 */
	async GetUserListAccessQueueTask(request: GetUserListAccessQueueTaskRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersListService',
			Method: 'GetUserListAccessQueueTask',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Получение информации о пользователе по Id
	 */
	async getByIdAsync(request: GetByIdRequest): Promise<GetByIdResponse> {
		return new Promise<GetByIdResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersListService',
				Method: 'GetById',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetByIdResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetByIdResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить список пользователей и краткую информацыю о них
	 */
	async getOwnedUsersAsync(request: OwnedUsersRequest): Promise<OwnedUsersResponse> {
		return new Promise<OwnedUsersResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersListService',
				Method: 'GetOwnedUsers',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<OwnedUsersResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as OwnedUsersResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка пользователей с краткой информацией и доступами по проекту/рабочей области
	 */
	async getOwnedUsersWithAccessAsync(request: GetOwnedUsersWithAccessRequest): Promise<GetOwnedUsersWithAccessResponse> {
		return new Promise<GetOwnedUsersWithAccessResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersListService',
				Method: 'GetOwnedUsersWithAccess',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetOwnedUsersWithAccessResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetOwnedUsersWithAccessResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение доступа по номеру задачи
	 */
	async getUserRoleByTaskIdsAsync(request: GetUserRoleByTaskIdsRequset): Promise<GetUserRoleByTaskIdsResponse> {
		return new Promise<GetUserRoleByTaskIdsResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersListService',
				Method: 'GetUserRoleByTaskIds',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetUserRoleByTaskIdsResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetUserRoleByTaskIdsResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить список пользователей и краткую информацыю о них с проектами
	 */
	async getOwnedDetailUsersAsync(request: GetOwnedDetailUsersRequest): Promise<GetOwnedDetailUsersResponse> {
		return new Promise<GetOwnedDetailUsersResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersListService',
				Method: 'GetOwnedDetailUsers',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetOwnedDetailUsersResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetOwnedDetailUsersResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить список админов проекта
	 */
	async getAdminsListForProjectAsync(request: AdminsListForProjectRequest): Promise<Array<ShortProfile>> {
		return new Promise<Array<ShortProfile>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersListService',
				Method: 'GetAdminsListForProject',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Array<ShortProfile>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<ShortProfile>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение детального списка админов проекта
	 */
	async getAdminsListForProjectDetailAsync(request: GetAdminsListForProjectDetailRequest): Promise<GetAdminsListForProjectDetailResponse> {
		return new Promise<GetAdminsListForProjectDetailResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersListService',
				Method: 'GetAdminsListForProjectDetail',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetAdminsListForProjectDetailResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetAdminsListForProjectDetailResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка сотрудников с доступом к проекту
	 */
	async getEmployeesWithAccessToProjectAsync(request: GetEmployeesWithAccessToProjectRequest): Promise<GetEmployeesWithAccessToProjectResponse> {
		return new Promise<GetEmployeesWithAccessToProjectResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersListService',
				Method: 'GetEmployeesWithAccessToProject',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetEmployeesWithAccessToProjectResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetEmployeesWithAccessToProjectResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка пользователей которым доступна очередь задач
	 */
	async getUserListAccessQueueTaskAsync(request: GetUserListAccessQueueTaskRequest): Promise<GetUserListAccessQueueTaskResponse> {
		return new Promise<GetUserListAccessQueueTaskResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersListService',
				Method: 'GetUserListAccessQueueTask',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetUserListAccessQueueTaskResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetUserListAccessQueueTaskResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}